import React from 'react';

import './loading.scss';

export const LoadingStoreCallout = () => {
  return (
    <div className="loading-rental-pricing--copy">
      <div className="loading-container">
        <div className="loading-bar md" />
        <div className="loading-bar md" />
      </div>
    </div>
  );
};